import { GenericCell } from '@components/design/migrated/Table';
import OverIcon from '@assets/over.svg';
import UnderIcon from '@assets/under.svg';
import { Rank } from '@models/Products';
import * as styles from '@components/top-selling-products/products-table-cell/ProductTableCell.module.scss';

interface Props {
  ranking?: Rank;
}

const getRankingWithIcon = (ranking?: Rank) => {
  if (!ranking || ranking.rank === 0) {
    return (
      <div className={styles.ProductTableCell__TableCell_IconAndText}>
        <div className={styles.ProductTableCell__TableCell_Change}>{'--'}</div>
      </div>
    );
  }

  if (ranking.position === 'UP') {
    return (
      <div className={styles.ProductTableCell__TableCell_IconAndText}>
        <div className={styles.ProductTableCell__TableCell_Change}>{ranking.rank}</div>
        <div className={styles.ProductTableCell__TableCell_ArrowAndRank}>
          <div>
            <img src={OverIcon} alt={ranking.position} className={styles.ProductTableCell__TableCell_WithIconLeft} />
          </div>
          <div className={styles.ProductTableCell__TableCell_Change_Positive}>{ranking.change}</div>
        </div>
      </div>
    );
  }

  if (ranking.position === 'DOWN') {
    return (
      <div className={styles.ProductTableCell__TableCell_IconAndText}>
        <div className={styles.ProductTableCell__TableCell_Change}>{ranking.rank}</div>
        <div className={styles.ProductTableCell__TableCell_ArrowAndRank}>
          <div>
            <img src={UnderIcon} alt={ranking.position} className={styles.ProductTableCell__TableCell_WithIconLeft} />
          </div>
          <div className={styles.ProductTableCell__TableCell_Change_Negative}>{ranking.change}</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.ProductTableCell__TableCell_IconAndText}>
      <div className={styles.ProductTableCell__TableCell_Change}>{ranking.rank}</div>
      <div className={styles.ProductTableCell__TableCell_ArrowAndRank}>{'--'}</div>
    </div>
  );
};

const ProductsTableRankCell: React.FC<Props> = ({ ranking }) => {
  return <GenericCell primary={getRankingWithIcon(ranking)} />;
};

export default ProductsTableRankCell;
